import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MailOpen } from "lucide-react";
import { PageHeader } from "@/components/Layout";
import { MailTable } from "@/components/MailTable";
import { api, fmtDate } from "@/lib/api";

const Awaiting = ({ items }) => (
  <div data-testid="mailbox-awaiting" className="mb-8 space-y-3">
    <p className="text-xs font-semibold uppercase tracking-wider text-amber-700 dark:text-amber-400">Waiting for you to claim</p>
    {items.map((m) => (
      <div key={m.claim_token} data-testid={`awaiting-${m.reference}`} className="flex flex-wrap items-center gap-4 rounded-xl border border-amber-200 bg-amber-50 dark:border-amber-900 dark:bg-amber-950/30 p-4">
        <MailOpen size={22} className="text-amber-600 shrink-0" />
        <div className="flex-1 min-w-[180px]">
          <p className="text-sm font-semibold">Letter from {m.sender_name}</p>
          <p className="text-xs text-slate-500">Ref {m.reference} · sent {fmtDate(m.sent_at)}{m.expires_at ? ` · claim by ${fmtDate(m.expires_at)}` : ""}</p>
        </div>
        <Link to={`/claim/${m.claim_token}`} data-testid={`awaiting-claim-btn-${m.reference}`} className="px-5 py-2.5 rounded-full bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-500 transition-colors">Claim now</Link>
      </div>
    ))}
  </div>
);

export default function Mailbox() {
  const [rows, setRows] = useState(null);
  const [awaiting, setAwaiting] = useState([]);
  useEffect(() => {
    api.get("/mail/received").then((r) => setRows(r.data));
    api.get("/mail/awaiting").then((r) => setAwaiting(r.data)).catch(() => setAwaiting([]));
  }, []);
  return (
    <div data-testid="mailbox-page">
      <PageHeader eyebrow="Received" title="Your mailbox" />
      <p className="text-sm text-slate-500 mb-6 max-w-2xl">Letters appear here once you've claimed them by confirming your name, postal address and a one-time code. Letters can be viewed or downloaded as a PDF.</p>
      {awaiting.length > 0 && <Awaiting items={awaiting} />}
      {rows && <MailTable rows={rows} mode="received" empty="No letters yet. When someone sends you a letter you'll get an email and SMS with a claim link." />}
    </div>
  );
}
